if (!customElements.get('product-info')) {
    customElements.define(
      'product-info',
      class ProductInfo extends HTMLElement {
        onVariantChangeUnsubscriber = undefined;
        cartUpdateUnsubscriber = undefined;
        abortController = undefined;
        productInfoRequestId = 0;
        pendingRequestUrl = null;
        preProcessHtmlCallbacks = [];
        postProcessHtmlCallbacks = [];
        readMoreBtn = document.querySelector('.read-more-btn')
        descriptionContent = document.querySelector('.description-content')
        descriptionContainer = document.querySelector('.pdp-details-description-text')
        buyNowButton = document.querySelector('.buy-now');

        constructor() {
          super();
          if (this.readMoreBtn && this.descriptionContent) {
            if (this.descriptionContent.scrollHeight > 105) {
              this.readMoreBtn.style.display = 'inline-block';
            }
  
            this.readMoreBtn.addEventListener('click', () => this.toggleDescription());
          }
        }
  
        connectedCallback() {
          this.initializeProductSwapUtility();
  
          this.onVariantChangeUnsubscriber = subscribe(
            PUB_SUB_EVENTS.optionValueSelectionChange,
            this.handleOptionValueChange.bind(this)
          );
  
          this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));

          this.handleProductVariantUpdate();
        }
  
        addPreProcessCallback(callback) {
          this.preProcessHtmlCallbacks.push(callback);
        }
  
        disconnectedCallback() {
          this.onVariantChangeUnsubscriber();
          this.cartUpdateUnsubscriber?.();
        }
  
        initializeProductSwapUtility() {
          this.preProcessHtmlCallbacks.push((html) =>
            html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
          );
          this.postProcessHtmlCallbacks.push((newNode) => {
            window?.Shopify?.PaymentButton?.init();
            window?.ProductModel?.loadShopifyXR();
          });
        }
  
        handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
          if (!this.contains(event.target)) return;
  
          this.resetProductFormState();
  
          const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
          this.pendingRequestUrl = productUrl;
          const shouldSwapProduct = this.dataset.url !== productUrl;
          const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;
  
          this.renderProductInfo({
            requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
            targetId: target.id,
            callback: shouldSwapProduct
              ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
              : this.handleUpdateProductInfo(productUrl),
          });
        }

        toggleDescription() {       
          this.descriptionContainer.classList.toggle('expanded');
          this.readMoreBtn.textContent = this.descriptionContainer.classList.contains('expanded') 
            ? 'Read Less' 
            : 'Read More';
        }
  
        resetProductFormState() {
          const productForm = this.productForm;
          productForm?.handleErrorMessage();
        }
  
        handleSwapProduct(productUrl, updateFullPage) {
          return (html) => {
            this.productModal?.remove();
  
            const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
            const variant = this.getSelectedVariant(html.querySelector(selector));
            this.updateURL(productUrl, variant?.id);
  
            if (updateFullPage) {
              document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;
  
              HTMLUpdateUtility.viewTransition(
                document.querySelector('main'),
                html.querySelector('main'),
                this.preProcessHtmlCallbacks,
                this.postProcessHtmlCallbacks
              );
            } else {
              HTMLUpdateUtility.viewTransition(
                this,
                html.querySelector('product-info'),
                this.preProcessHtmlCallbacks,
                this.postProcessHtmlCallbacks
              );
            }
          };
        }
  
        renderProductInfo({ requestUrl, targetId, callback }) {
          this.abortController?.abort();
          this.abortController = new AbortController();
          const requestId = ++this.productInfoRequestId;
          const abortController = this.abortController;
  
          fetch(requestUrl, { signal: abortController.signal })
            .then((response) => response.text())
            .then((responseText) => {
              if (requestId !== this.productInfoRequestId || abortController.signal.aborted) return;

              this.pendingRequestUrl = null;
              const html = new DOMParser().parseFromString(responseText, 'text/html');
              callback(html);
            })
            .then(() => {
              if (requestId !== this.productInfoRequestId || abortController.signal.aborted) return;

              // set focus to last clicked option value
              document.querySelector(`#${targetId}`)?.focus();
            })
            .catch((error) => {
              if (error.name === 'AbortError') {
                console.log('Fetch aborted by user');
              } else {
                console.error(error);
              }
            })
            .finally(() => {
              if (this.abortController === abortController) {
                this.abortController = undefined;
              }
            });
        }
  
        getSelectedVariant(productInfoNode) {
          const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
          return !!selectedVariant ? JSON.parse(selectedVariant) : null;
        }
  
        buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
          const params = [];
  
          !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);
  
          if (optionValues.length) {
            params.push(`option_values=${optionValues.join(',')}`);
          }
  
          return `${url}?${params.join('&')}`;
        }
  
        updateOptionValues(html) {
          const currentVariantSelects = this.variantSelectors;
          const newVariantSelects = html.querySelector('variant-selects');

          if (!currentVariantSelects || !newVariantSelects) return;

          if (!this.syncVariantSelectsInPlace(currentVariantSelects, newVariantSelects)) {
            HTMLUpdateUtility.replaceNode(currentVariantSelects, newVariantSelects, this.preProcessHtmlCallbacks);
          }
        }

        syncVariantSelectsInPlace(currentVariantSelects, newVariantSelects) {
          const currentControls = Array.from(currentVariantSelects.querySelectorAll('select, input[type="radio"]'));
          const newControls = Array.from(newVariantSelects.querySelectorAll('select, input[type="radio"]'));

          if (currentControls.length !== newControls.length) return false;

          for (let index = 0; index < currentControls.length; index++) {
            const control = currentControls[index];
            const newControl = newControls[index];

            if (control.tagName !== newControl.tagName || control.type !== newControl.type) return false;

            this.syncElementAttributes(control, newControl);

            if (control.tagName === 'SELECT') {
              if (control.options.length !== newControl.options.length) return false;

              for (let optionIndex = 0; optionIndex < control.options.length; optionIndex++) {
                const option = control.options[optionIndex];
                const newOption = newControl.options[optionIndex];
                if (!newOption) return false;

                this.syncElementAttributes(option, newOption);
                option.selected = newOption.selected;
                option.disabled = newOption.disabled;
              }

              continue;
            }

            control.checked = newControl.checked;
            control.disabled = newControl.disabled;

            const label = currentVariantSelects.querySelector(`label[for="${CSS.escape(control.id)}"]`);
            const newLabel = newVariantSelects.querySelector(`label[for="${CSS.escape(newControl.id)}"]`);

            if (label && newLabel) {
              this.syncElementAttributes(label, newLabel);
              label.innerHTML = newLabel.innerHTML;
            }
          }

          currentVariantSelects.querySelectorAll('.form__label [data-selected-value], .form__label .value-selected').forEach((label, index) => {
            const newLabel = newVariantSelects.querySelectorAll('.form__label [data-selected-value], .form__label .value-selected')[index];
            if (newLabel) label.innerHTML = newLabel.innerHTML;
          });

          const currentSelectedVariant = currentVariantSelects.querySelector('[data-selected-variant]');
          const newSelectedVariant = newVariantSelects.querySelector('[data-selected-variant]');

          if (currentSelectedVariant && newSelectedVariant) {
            currentSelectedVariant.innerHTML = newSelectedVariant.innerHTML;
          }

          return true;
        }

        syncElementAttributes(element, newElement) {
          element.getAttributeNames().forEach((attribute) => {
            if (!newElement.hasAttribute(attribute)) {
              element.removeAttribute(attribute);
            }
          });

          newElement.getAttributeNames().forEach((attribute) => {
            element.setAttribute(attribute, newElement.getAttribute(attribute));
          });
        }

        setDynamicButtonText(button, text) {
          const label = button?.querySelector('span');
          if (!label || !text) return;

          label.textContent = text;
          label.setAttribute('data-weglot-dynamic', 'text');
          label.setAttribute('data-weglot-source', text);
        }

        refreshDynamicTranslations(root = this) {
          root.dispatchEvent(new CustomEvent('fk:dynamic-content:rendered', { bubbles: true, detail: { root } }));

          if (window.fkWeglotDynamic && typeof window.fkWeglotDynamic.refresh === 'function') {
            window.fkWeglotDynamic.refresh(root);
          }
        }
  
        handleUpdateProductInfo(productUrl) {
          return (html) => {
            const variant = this.getSelectedVariant(html);
  
            this.pickupAvailability?.update(variant);
            this.updateOptionValues(html);
            this.updateURL(productUrl, variant?.id);
            this.updateVariantInputs(variant?.id);
            this.handleProductVariantUpdate();
  
            if (!variant) {
              return;
            }
            
            const productForms = document.querySelectorAll('product-form')
            const fetchedSubmitButton = html.querySelector(`.ProductSubmitButton-${this.sectionId}`);
            const isPreorder = fetchedSubmitButton?.dataset.preorder === 'true';
            productForms.forEach((productForm) => {
              const submitButton = productForm.querySelector(`.ProductSubmitButton-${this.sectionId}`);
              const submitButtonText = submitButton?.querySelector('span');
            
              if (variant.available) {
                submitButton?.removeAttribute('disabled');
                if (this.buyNowButton) {
                  this.buyNowButton.style.display = 'block';
                  this.buyNowButton?.removeAttribute('disabled');
                  this.setDynamicButtonText(this.buyNowButton, window.variantStrings.buyNow);
                }
                if (submitButtonText) this.setDynamicButtonText(submitButton, isPreorder ? window.variantStrings.preorder : window.variantStrings.addToCart);
                if (submitButton) submitButton.dataset.preorder = String(isPreorder);
              } else {
                submitButton?.setAttribute('disabled', 'disabled');
                if (this.buyNowButton) {
                  this.buyNowButton.style.display = 'none';
                }
                if (submitButtonText) this.setDynamicButtonText(submitButton, window.variantStrings.soldOut);
              }
            });

            this.refreshDynamicTranslations(this);

            const updateProductPrices = (variant) => {
              let compareAtPriceElement = document.querySelector('[data-testid="pdp-compare-at-price"]');
              let discountBadgeElement = document.querySelector('[data-testid="pdp-discount-badge"]');
              const actualPriceElement = document.querySelector('[data-testid="pdp-actual-price"]');
              const priceContainer = document.querySelector('.pdp-details-product-price');
              let memberPriceBadgeElement = priceContainer?.querySelector('[data-member-price-badge]');
              const mediaGallery = document.querySelector('.media-gallery');
              const displayPrice = window.memberPricing?.getDisplayPrice
                ? window.memberPricing.getDisplayPrice(variant, JSON.parse(this.dataset.productTags || '[]'))
                : {
                    price: variant.price,
                    compareAtPrice: variant.compare_at_price && variant.compare_at_price > variant.price ? variant.compare_at_price : null,
                    isMemberPrice: false,
                  };

              if (displayPrice.compareAtPrice) {
                if (!compareAtPriceElement && priceContainer && actualPriceElement) {
                  compareAtPriceElement = document.createElement('div');
                  compareAtPriceElement.className = 'pdp-details-compare-price';
                  compareAtPriceElement.setAttribute('data-testid', 'pdp-compare-at-price');

                  actualPriceElement.insertAdjacentElement('afterend', compareAtPriceElement);
                }

                if (!discountBadgeElement && mediaGallery) {
                  discountBadgeElement = document.createElement('div');
                  discountBadgeElement.className = 'pdp-details-discount-pill';
                  discountBadgeElement.setAttribute('data-testid', 'pdp-discount-badge');

                  mediaGallery.insertBefore(discountBadgeElement, mediaGallery.firstElementChild);
                }

                const discountPercentage = Math.round(((displayPrice.compareAtPrice - displayPrice.price) / displayPrice.compareAtPrice) * 100);
                if (discountBadgeElement) {
                  discountBadgeElement.textContent = `-${discountPercentage}%`;
                  discountBadgeElement.hidden = false;
                }

                if (compareAtPriceElement) {
                  compareAtPriceElement.textContent = formatMoney(displayPrice.compareAtPrice);
                  compareAtPriceElement.hidden = false;
                }
              } else {
                if (compareAtPriceElement) {
                  compareAtPriceElement.hidden = true;
                }
                if (discountBadgeElement) {
                  discountBadgeElement.hidden = true;
                }
              }

              if (displayPrice.isMemberPrice && !memberPriceBadgeElement && priceContainer) {
                memberPriceBadgeElement = document.createElement('div');
                memberPriceBadgeElement.className = 'pdp-member-price-badge';
                memberPriceBadgeElement.setAttribute('data-member-price-badge', '');
                memberPriceBadgeElement.textContent = window.memberPricing?.label || '';

                priceContainer.insertBefore(memberPriceBadgeElement, priceContainer.firstElementChild);
              }

              if (memberPriceBadgeElement) {
                memberPriceBadgeElement.hidden = !displayPrice.isMemberPrice;
              }
            
              if (actualPriceElement) {
                actualPriceElement.textContent = formatMoney(displayPrice.price);
              }
            };
            
            updateProductPrices(variant);
  
            publish(PUB_SUB_EVENTS.variantChange, {
              data: {
                sectionId: this.sectionId,
                html,
                variant,
              },
            });

            this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));
          };
        }

        handleProductVariantUpdate(){
          const inputSelectors = document.querySelectorAll('.pdp-details .input-selector:has(.variant-color), .pdp-details  .input-selector:has(.variant-size)');
          inputSelectors.forEach(selector => {
              const radio = selector.querySelector(".color-radio[type='radio']:checked + label, .size-radio[type='radio']:checked + label");
              if (radio) {
                  const variantColorText = selector.querySelector(".variant-color")?.textContent?.trim();
                  const variantSizeText = selector.querySelector(".variant-size")?.textContent?.trim();
                  if (variantColorText) {
                      const colorSelectedSpan = document.querySelector("fieldset.color .value-selected");
                      if (colorSelectedSpan) {
                          colorSelectedSpan.textContent = variantColorText;
                      }
                  }
                  
                  if (variantSizeText) {
                      const sizeSelectedSpan = document.querySelector("fieldset.size .value-selected");

                      if (sizeSelectedSpan) {
                          sizeSelectedSpan.textContent = variantSizeText;
                      }
                  }
              }
          });
      }
  
        updateVariantInputs(variantId) {
          this.querySelectorAll(
            `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
          ).forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            input.value = variantId ?? '';
            input.dispatchEvent(new Event('change', { bubbles: true }));
          });
        }
  
                updateURL(url, variantId) {
          const baseUrl = url.split('?')[0]; // Remove any existing query parameters
          const variantParam = variantId ? `?variant=${variantId}` : '';
          
          this.querySelector('share-button')?.updateUrl(
            `${window.shopUrl}${baseUrl}${variantParam}`
          );

          if (this.dataset.updateUrl === 'false') return;
          window.history.replaceState({}, '', `${baseUrl}${variantParam}`);
        }
  
        get productForm() {
          return this.querySelector(`product-form`);
        }
  
        get pickupAvailability() {
          return this.querySelector(`pickup-availability`);
        }
  
        get variantSelectors() {
          return this.querySelector('variant-selects');
        }
  
        get relatedProducts() {
          const relatedProductsSectionId = SectionId.getIdForSection(
            SectionId.parseId(this.sectionId),
            'related-products'
          );
          return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
        }
  
        get quickOrderList() {
          const quickOrderListSectionId = SectionId.getIdForSection(
            SectionId.parseId(this.sectionId),
            'quick_order_list'
          );
          return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
        }
  
    
        get relatedProducts() {
          const relatedProductsSectionId = SectionId.getIdForSection(
            SectionId.parseId(this.sectionId),
            'related-products'
          );
          return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
        }
  
        get quickOrderList() {
          const quickOrderListSectionId = SectionId.getIdForSection(
            SectionId.parseId(this.sectionId),
            'quick_order_list'
          );
          return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
        }
  
        get sectionId() {
          return this.dataset.originalSection || this.dataset.section;
        }
      }
    );
  }

  class HTMLUpdateUtility {
    /**
     * Used to swap an HTML node with a new node.
     * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
     *
     * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
     */
    static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
      preProcessCallbacks?.forEach((callback) => callback(newContent));
  
      const newNodeWrapper = document.createElement('div');
      HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
      const newNode = newNodeWrapper.firstChild;
  
      // dedupe IDs
      const uniqueKey = Date.now();
      oldNode.querySelectorAll('[id], [form]').forEach((element) => {
        element.id && (element.id = `${element.id}-${uniqueKey}`);
        element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
      });
  
      oldNode.parentNode.insertBefore(newNode, oldNode);
      oldNode.style.display = 'none';
  
      postProcessCallbacks?.forEach((callback) => callback(newNode));
  
      setTimeout(() => oldNode.remove(), 1);
    }

    static replaceNode(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
      preProcessCallbacks?.forEach((callback) => callback(newContent));

      const newNodeWrapper = document.createElement('div');
      HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
      const newNode = newNodeWrapper.firstChild;

      oldNode.parentNode.replaceChild(newNode, oldNode);

      postProcessCallbacks?.forEach((callback) => callback(newNode));
    }
  
    // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
    static setInnerHTML(element, html) {
      element.innerHTML = html;
      element.querySelectorAll('script').forEach((oldScriptTag) => {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach((attribute) => {
          newScriptTag.setAttribute(attribute.name, attribute.value);
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });
    }
  }
  
  
